import ActiveFiltersList from './ActiveFiltersList';

export { type ActiveFiltersListProps } from './ActiveFiltersList';
export default ActiveFiltersList;
